import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Select from 'react-select'

const DropDownComp = (props) => {

  return (
    <div className={props.wrapClass + " form-group newDropDwon"}>
      <Select
        isMulti={props.isMulti ? true : false}
        name={props.name}
        value={props?.value}
        onChange={(selectedValue) => {

          props.onChange(selectedValue);
        }}
        options={props.options}
        isDisabled={props.isDisabled}
        isClearable={true}
        placeholder={props.name}
        isOptionDisabled={(option) => option.isdisabled} // disable an option
      >
      </Select>

    </div >
  );

};

DropDownComp.propTypes = {
  heading: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.any.isRequired,
  placeholder: PropTypes.string.isRequired,
  errorState: PropTypes.string,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  wrapClass: PropTypes.string,
  isDisabled: PropTypes.bool
};

export default DropDownComp;
